import {Cloudinary} from "@cloudinary/url-gen";

export const cld = new Cloudinary({cloud: {cloudName: "dlj6q08ce"}});
